import { render, staticRenderFns } from "./Verfarmaco.vue?vue&type=template&id=6ef90226&scoped=true"
import script from "./Verfarmaco.vue?vue&type=script&lang=js"
export * from "./Verfarmaco.vue?vue&type=script&lang=js"
import style0 from "./Verfarmaco.vue?vue&type=style&index=0&id=6ef90226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef90226",
  null
  
)

export default component.exports